export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_06.6d683ca2.jpg";